import { getLogger } from '@nerdwallet/logging';
import localStorageHelper from './localStorage';

const SECONDS_IN_THIRTY_MINUTES = 1800;
const NUM_PAGE_VIEWS_DATE = 'numPageViewsDate';
const logger = getLogger('page-views');
export const NUM_PAGE_VIEWS = 'numPageViews';

export const setPageViews = () => {
  localStorageHelper.setItem(NUM_PAGE_VIEWS, 1);
  localStorageHelper.setItem(NUM_PAGE_VIEWS_DATE, Date.now());
};

export const isSameSession = () => {
  const timeDiffInMilliseconds =
    Date.now() - parseInt(localStorageHelper.getItem(NUM_PAGE_VIEWS_DATE), 10);
  const timeDiffInSeconds = timeDiffInMilliseconds / 1000;
  return timeDiffInSeconds < SECONDS_IN_THIRTY_MINUTES;
};

export const incrementPageViews = (originatingUrl: string) => {
  if (!localStorageHelper.getItem(NUM_PAGE_VIEWS) || !isSameSession()) {
    logger.debug(
      "local storage variable does't exist or session expired, resetting page views"
    );
    setPageViews();
    return;
  }
  if (localStorageHelper.getItem('previousUrl') === originatingUrl) {
    logger.debug("same page, don't increment page views");
    return;
  }
  logger.debug('incrementing page views');
  const numPageViews =
    parseInt(localStorageHelper.getItem(NUM_PAGE_VIEWS), 10) + 1;
  localStorageHelper.setItem(NUM_PAGE_VIEWS, numPageViews);
};

export const isSecondPageView = () => {
  return localStorageHelper.getItem(NUM_PAGE_VIEWS) === '2';
};
